import React from 'react';

import PropTypes from 'prop-types';

export default function BowIcon({ width = '43', height = '38' }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 43 38"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.4809 17.1919L22.844 20.2493L22.91 20.379L21.0664 18.8292L8.02051 30.8658L15.1603 30.5941L16.5066 37.9997L24.1901 22.8954L31.0407 36.3624L32.387 28.9568L39.5268 29.2285L26.4809 17.1919Z"
        fill="#E05353"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.0111 17.1919L22.3743 20.2493L22.4403 20.379L20.5967 18.8292L7.55078 30.8658L14.6905 30.5941L16.0369 37.9997L23.7204 22.8954L30.571 36.3624L31.9173 28.9568L39.057 29.2285L26.0111 17.1919Z"
        fill="#CA2525"
      />
      <path
        d="M0.679336 11.6076C0.333328 9.62986 1.92353 7.8144 3.92022 7.90761L20.6572 8.68892L22.4865 19.1448L6.89323 25.5773C5.07571 26.3271 3.06167 25.2246 2.7241 23.2951L0.679336 11.6076Z"
        fill="#E05353"
      />
      <path
        d="M40.3024 3.88297C39.9564 1.90525 37.8568 0.808928 36.0233 1.64863L20.6544 8.68727L22.4837 19.1431L39.2252 19.2737C41.1765 19.2889 42.6847 17.5 42.3472 15.5705L40.3024 3.88297Z"
        fill="#E05353"
      />
      <path
        d="M0.679336 13.2394C0.333328 11.2617 1.92353 9.44624 3.92022 9.53945L20.6572 10.3208L22.4865 20.7766L6.89323 27.2092C5.07571 27.9589 3.06167 26.8564 2.7241 24.927L0.679336 13.2394Z"
        fill="#CA2525"
      />
      <path
        d="M40.3024 5.52067C39.9564 3.54294 37.8568 2.44662 36.0233 3.28632L20.6544 10.325L22.4837 20.7808L39.2252 20.9114C41.1765 20.9266 42.6847 19.1377 42.3472 17.2082L40.3024 5.52067Z"
        fill="#CA2525"
      />
      <rect
        width="7.78156"
        height="19.5556"
        rx="3.89078"
        transform="matrix(0.958568 -0.284865 0.257753 0.966211 16.3867 6.48047)"
        fill="#E05353"
      />
      <rect
        width="7.78156"
        height="19.5556"
        rx="3.89078"
        transform="matrix(0.958568 -0.284865 0.257753 0.966211 16.0273 6.80859)"
        fill="#CA2525"
      />
    </svg>
  );
}

BowIcon.propTypes = {
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};
